import { Router } from "@angular/router";
import { saveAuth } from "src/app/util/auth";
import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";

@Component({
  selector: "app-admin-login",
  templateUrl: "./admin-login.component.html",
})
export class AdminLoginComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}
  loading = true;
  errorMessage = "";

  ngOnInit(): void {
    const params = new URLSearchParams(location.search);
    const payload = {
      Password: "xxx",
      StudentNo: params.get("studentNo") || "",
      AuthToken: params.get("token") || "",
      AuthDateTime: params.get("time") || "",
    };

    const httpParams = new HttpParams({
      fromObject: payload,
    });

    const baseUrl = `${environment.BASE_URL}/users/login`;
    this.httpClient
      .post(baseUrl, payload)
      .subscribe({
        next: (res: any) => {
          saveAuth({ ...res?.Data, Matric: res?.Data.Student.StudentNo });
          this.router.navigateByUrl("/");
        },
        error: (err: any) => {
          this.loading = false;
          this.errorMessage = errorHandler(err).message;
        },
      })
      .add(() => {
        saveAuth([], "_courses");
        saveAuth({}, "_checks");
        saveAuth(null, "_news");
        saveAuth(null, "_deadlines");
        saveAuth([], "_accommodation");
        saveAuth([], "_slider");
        saveAuth([], "_requirements");
        saveAuth({}, "_passport");
        saveAuth(false, "_isApplication");
      });
  }
}
